import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const rideryCodesService = {
  getListRideryCodes: async (data) => {
    const response = await authInstance
      .get(`${url}/externalDiscountCode/?` + new URLSearchParams(data))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  setInventory: async (data) => {
    const response = await authInstance
      .post(`${url}/externalDiscountCode/create/`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  updateStatus: async (id, data) => {
      const response = await authInstance
        .put(`${url}/externalDiscountCode/${id}`, data)
        .then(async (response) => {
          return response;
        })
        .catch(function (error) {
          error.data = [];
          return error;
        });
      return response;
    },
};
